import axios from "axios";

const axiosAPI = axios.create({
  baseURL: "https://api-babydoge.katanainu.com",
});

export default axiosAPI;
